import { TrashIcon } from "@heroicons/react/24/outline";

function Note(props) {
  const { note, user, showDelete, onDelete } = props;

  return (
    <div className="flex flex-col gap-y-4 border rounded-lg p-4 bg-yellow-100">
      <div className="flex justify-between">
        <p className="text-sm font-semibold">
          {user?.firstName} {user?.lastName}
        </p>
        {showDelete && (
          <TrashIcon onClick={onDelete} className="text-red-500 size-4 cursor-pointer hover:text-red-800" />
        )}
      </div>
      <p className="text-sm font-light text-gray-600">{note.note}</p>
    </div>
  );
}

export default Note;
